import React from "react";

const WhyChooseUs = () => {
  return (
    <React.Fragment>
      <section className="h2_nh_choose-area pt-100 pb-60">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="h2_nh_choose-img mr-65 mb-40">
                <img src="/images/about-us-3.png" alt="" className="w-100" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="h2_nh_choose-content ml-70 mb-40">
                <div className="nh_section-area mb-45">
                  <span className="nh_section-subtitle">Why Choose Us</span>
                  <h2 className="nh_section-title mb-25 pb-2">
                    Why Choose Mitra Recharge?
                  </h2>
                  <p className="nh_section-text mb-25">
                    Mitra Recharge offers a fast, secure, and hassle-free
                    platform for Mobile, DTH, and Google Play recharges. With
                    attractive commission rates, instant transactions, and 24/7
                    support, we ensure a smooth experience for our customers and
                    partners. Our user-friendly platform and commitment to
                    reliability make us the preferred choice for all your
                    recharge needs.
                  </p>

                  <div class="h5_nh_about-list mb-25">
                    <ul>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>Fast & Secure
                      </li>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>Secure
                        Platform
                      </li>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>Attractive
                        Commission
                      </li>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>24/7 Support
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="h2_nh_about-btn">
                  <a href="/about_us" className="nh_theme-btn">
                    More Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default WhyChooseUs;
